import React, { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { LGTabPanel } from "../../molecules/LGTabPanel";
import { useCompany } from "../../contexts/CompanyContext";
import AccountingInboundsTable from "../../organisms/Inventory/AccountingInboundsTable";
import AccountingOutboundsTable from "../../organisms/Inventory/AccountingOutboundsTable";
import SyntheticInboundStockMoveCrud from "../../organisms/LGCrud/SyntheticInboundStockMoveCrud";
import SyntheticOutboundStockMoveCrud from "../../organisms/LGCrud/SyntheticOutboundStockMoveCrud";
import SyntheticInventoryReportTable from "../../organisms/Inventory/SyntheticInventoryReportTable";

const AccountingInventoryScreen = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompany } = useCompany();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label="Ordenes de compra" />
          <Tab label="Entradas" />
          <Tab label="Crear salidas a partir de entradas" />
          <Tab label="Salidas" />
          <Tab label="Movimientos" />
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <Box sx={{ mt: 8 }}>
          <AccountingInboundsTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <Box sx={{ mt: 8 }}>
          <SyntheticInboundStockMoveCrud />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={2}>
        <Box sx={{ mt: 8 }}>
          <AccountingOutboundsTable />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={3}>
        <Box sx={{ mt: 8 }}>
          <SyntheticOutboundStockMoveCrud />
        </Box>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={4}>
        <Box sx={{ mt: 8 }}>
          <SyntheticInventoryReportTable />
        </Box>
      </LGTabPanel>
    </DashboardLayout>
  );
};

export default AccountingInventoryScreen;

